import React from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableBodyCell,
} from "../../../StyledComponents";
import { Div } from "../../Styles";
import { TxtSpan, NewTableHeadCell, AvatarFrame, AvatarTxt } from "../styles";
import EmptyData from "../../../StyledComponents/EmptyData";

const HEADER_GRID = "18% 12% 12% 10% 10% 10% 10% 18%";

const RefundHistoryTable = ({ RefundLists = [] }) => {
  const normalizeProviderName = (row) => {
    const keys = [
      "provider_name",
      "providerName",
      "Provider",
      "facilityname",
      "doctor_name",
      "facility_name",
      "username",
    ];
    for (let k of keys) {
      if (row[k] && typeof row[k] === "string" && row[k].trim() !== "")
        return row[k].trim();
    }
    // fallback: search any string field containing letters
    for (let v of Object.values(row)) {
      if (typeof v === "string" && /[a-zA-Z]/.test(v)) return v.trim();
    }
    return "-";
  };

  const getInvoiceId = (row) => {
    const idKeys = [
      "invoice_id",
      "invoice_no",
      "InvoiceID",
      "Invoice",
      "receipt_id",
      "invo_id",
      "id",
      "receipt_no",
    ];
    for (let k of idKeys) {
      if (row[k] && String(row[k]).length > 0) return row[k];
    }
    return "-";
  };

  const formatAmount = (val) => {
    const num = parseFloat(val || 0);
    if (isNaN(num)) return "0.00";
    return num.toFixed(2);
  };

  const getDate = (row) => {
    return (
      row.refund_date ||
      row.invoice_date ||
      row.generatedDate ||
      row.date ||
      "-"
    );
  };

  return (
    <Div>
      <Table>
        <TableHead>
          <TableRow
            display="grid"
            tempColumns={HEADER_GRID}
            background="#F1F7FF"
          >
            <NewTableHeadCell padding="16px 12px">Provider</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">
              Generated On
            </NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">Invoice</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">Billed</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">Paid</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">Refunded</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">Type</NewTableHeadCell>
            <NewTableHeadCell padding="16px 10px">Reason</NewTableHeadCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {RefundLists.length !== 0 ? (
            RefundLists.map((row, ind) => (
              <TableRow
                display="grid"
                tempColumns={HEADER_GRID}
                key={ind}
                alignItems="center"
                id={`bil_refund-row-${ind}`}
              >
                <TableBodyCell padding="18px 12px">
                  <Div
                    display="flex"
                    alignItems="center"
                    style={{ minWidth: 0 }}
                  >
                    <AvatarFrame style={{ marginRight: "10px", flexShrink: 0 }}>
                      {row.provider_img ? (
                        <img
                          src={row.provider_img}
                          alt={normalizeProviderName(row)}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <AvatarTxt>
                          {(normalizeProviderName(row) || "P").charAt(0)}
                        </AvatarTxt>
                      )}
                    </AvatarFrame>
                    <TxtSpan
                      fontWeight="500"
                      color="#1e293b"
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "200px",
                      }}
                      title={normalizeProviderName(row)}
                    >
                      {normalizeProviderName(row)}
                    </TxtSpan>
                  </Div>
                </TableBodyCell>

                <TableBodyCell padding="18px 10px">
                  <TxtSpan color="#64748b" style={{ whiteSpace: "nowrap" }}>
                    {getDate(row)}
                  </TxtSpan>
                </TableBodyCell>

                <TableBodyCell padding="18px 10px">
                  <TxtSpan color="#2b59ff" fontWeight="500">
                    {getInvoiceId(row)}
                  </TxtSpan>
                </TableBodyCell>

                <TableBodyCell padding="18px 10px">
                  <TxtSpan fontWeight="600" color="#1e293b">
                    $
                    {formatAmount(
                      row.billedamount ||
                        row.total_billed ||
                        row.total_amount ||
                        row.amount,
                    )}
                  </TxtSpan>
                </TableBodyCell>

                <TableBodyCell padding="18px 10px">
                  <TxtSpan fontWeight="600" color="#1e293b">
                    $
                    {formatAmount(
                      row.paidamount ||
                        row.paid ||
                        row.pay_total ||
                        row.balance,
                    )}
                  </TxtSpan>
                </TableBodyCell>

                <TableBodyCell padding="18px 10px">
                  <TxtSpan fontWeight="600" color="#1e293b">
                    $
                    {formatAmount(
                      row.refund_amt ||
                        row.refunded ||
                        row.refund_amount ||
                        row.refunded_amt,
                    )}
                  </TxtSpan>
                </TableBodyCell>

                <TableBodyCell padding="18px 10px">
                  <TxtSpan color="#475569">
                    {row.type || row.paymentMethod || row.payment_method || "-"}
                  </TxtSpan>
                </TableBodyCell>

                <TableBodyCell padding="18px 10px">
                  <TxtSpan color="#475569">
                    {row.reason || row.refund_reason || "-"}
                  </TxtSpan>
                </TableBodyCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableBodyCell colSpan={8} textAlign="center">
                <EmptyData />
              </TableBodyCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Div>
  );
};

export default RefundHistoryTable;
